import React, { Component } from "react";
import TimePicker from "material-ui-pickers/TimePicker";
import Grid from "@material-ui/core/Grid";
import parse from "date-fns/parse";

const week = [
  "Lundi",
  "Mardi",
  "Mercredi",
  "Jeudi",
  "Vendredi",
  "Samedi",
  "Dimanche"
];

export default class InformationsTimetable extends Component {
  state = {};

  render() {
    const { timetable, changeHour } = this.props;
    return week.map(day => (
      <Grid
        key={day}
        container
        spacing={16}
        alignItems="center"
        justify="center"
      >
        <Grid item xs={3} sm={2}>
          <div>{day}</div>
        </Grid>
        <Grid item xs={4} sm={3}>
          <TimePicker
            clearable
            ampm={false}
            label="Ouverture"
            invalidLabel=""
            invalidDateMessage=""
            value={
              timetable && timetable[day] && timetable[day].open
                ? parse(timetable[day].open, "HH'h'mm", new Date())
                : ""
            }
            onChange={changeHour(day, "open")}
            fullWidth
          />
        </Grid>
        <Grid item xs={4} sm={3}>
          <TimePicker
            clearable
            ampm={false}
            label="Fermeture"
            invalidLabel=""
            invalidDateMessage=""
            value={
              timetable && timetable[day] && timetable[day].close
                ? parse(timetable[day].close, "HH'h'mm", new Date())
                : ""
            }
            onChange={changeHour(day, "close")}
            fullWidth
          />
        </Grid>
      </Grid>
    ));
  }
}



// WEBPACK FOOTER //
// ./src/components/informations/InformationsTimetable.js